<template>
  <div class="px-10">
    <v-row no-gutters>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col
            cols="4"
            class="my-auto"
          >
            <span class="font-weight-bold">Join Date</span>
          </v-col>
          <v-col
            cols="1"
            class="my-auto"
          >
            :
          </v-col>
          <v-col
            cols="7"
            class="my-auto"
          >
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ joinDate ? $moment(joinDate, 'YYYY-MM-DD').format('D MMM YYYY') :'N/A' }}
              <employee-profile-job-dialog-edit-join-date
                v-if="$hasPermissionTo(['update employee join date']) && !isMyProfile && !isResigned"
                :employee-uid="employeeUid"
                :join-date="joinDate"
                :confirm-date="confirmDate ? confirmDate : null"
                @updated="loadJobDetails();$emit('updated')"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col cols="5">
            <span class="font-weight-bold">Confirm Date</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="6">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ confirmDate ? $moment(confirmDate, 'YYYY-MM-DD').format('D MMM YYYY') :'N/A' }}
              <employee-profile-job-dialog-edit-confirm-date
                v-if="$hasPermissionTo(['update employee confirm date']) && !isMyProfile && !isResigned"
                :employee-uid="employeeUid"
                :confirm-date="confirmDate"
                :join-date="joinDate"
                @updated="loadJobDetails();$emit('updated')"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri pb-3"
        >
          <v-col cols="2">
            <span class="font-weight-bold">Grade</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="9">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ position && (position || {}).job_grade ? ((position||{}).job_grade||{}).name:'N/A' }}
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1">
        <employee-profile-job-rehire-dialog-edit
          v-if="$hasPermissionTo(['create employee separations']) && !loading && isEmployeeResigned(effectiveDate)"
          :employee-uid="employeeUid"
          :rehire-min-date="effectiveDate ? effectiveDate : ''"
          @updated="loadJobDetails();$emit('updated')"
        />
        <employee-profile-job-separation-dialog-create
          v-if="$hasPermissionTo(['create employee separations']) && !loading && !isEmployeeResigned(effectiveDate) && !isMyProfile"
          :employee-uid="employeeUid"
          :separation-min-date="confirmDate ? confirmDate : joinDate"
          @created="loadJobDetails();$emit('updated')"
        />
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri pb-3"
        >
          <v-col cols="4">
            <span class="font-weight-bold">Department</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="7">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ department ? (department||{}).name:'N/A' }} </span>
                 
                </template>
                <span class="font-weight-bold">Section: {{ section? (section||{}).name :'N/A' }}</span>
              </v-tooltip>
               
              <employee-profile-job-dialog-list-departments
                v-if="!loading"
                :employee-uid="employeeUid"
                :join-date="joinDate"
                :is-resigned="isResigned"
                @created="loadJobDetails();$emit('updated')"
              />

              <employee-profile-job-dialog-edit-department
                v-if="$hasPermissionTo(['update employee department']) && !isMyProfile && !isResigned"
                :employee-uid="employeeUid"
                :department="department"
                :section="section"
                @updated="loadJobDetails();$emit('updated')"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col> 
      <v-col cols="3">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col cols="5">
            <span class="font-weight-bold">Year of Service</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="6">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ yearOfService ? (yearOfService+' year(s)' ):'N/A' }}
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col cols="2">
            <span class="font-weight-bold">Group</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="9">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_group ? (((position||{}).job_grade||{}).job_group||{}).name:'N/A' }}
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" />
    </v-row>

    <v-row no-gutters>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri pb-3"
        >
          <v-col cols="4">
            <span class="font-weight-bold">Base Location</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col
            cols="7"
          >
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ baseLocation ? baseLocation:'N/A' }}
              <employee-profile-job-dialog-edit-base-location
                v-if="$hasPermissionTo(['update employee base location']) && !isMyProfile && !isResigned"
                :employee-uid="employeeUid"
                :state="state"
                :city="city"
                @updated="loadJobDetails()"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col cols="5">
            <span class="font-weight-bold">Last Working Date</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="6">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ lastWorkingDate ? $moment(lastWorkingDate, 'YYYY-MM-DD').format('D MMM YYYY'):'N/A' }}
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col cols="2">
            <span class="font-weight-bold">Category</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="9">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_category ? (((position||{}).job_grade||{}).job_category||{}).name:'N/A' }}
            </span> 
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri pb-3"
        >
          <v-col cols="4">
            <span class="font-weight-bold">Probation Due Date</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="6">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ calculateProbationDueDate(joinDate, ((position || {}).job_grade || {}).job_category) }}
              <employee-profile-job-dialog-edit-probation-due-date
                v-if="$hasPermissionTo(['update employee join date']) && !isMyProfile && !isResigned && currentNormalHireProbation"
                :employee-uid="employeeUid"
                :probation-due-date="currentNormalHireProbation.end_date"
                @updated="loadJobDetails()"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="3">
        <v-row
          no-gutters
          class="font-16 font-calibri pb-3"
        >
          <v-col cols="5">
            <span class="font-weight-bold">Effective Date</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="6">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ effectiveDate ? $moment(effectiveDate, 'YYYY-MM-DD').format('D MMM YYYY'):'N/A' }}
  
              <employee-profile-job-separation-dialog-list
                v-if="$hasPermissionTo(['create employee separations']) && !loading && !isMyProfile"
                :employee-uid="employeeUid"
                :separation-min-date="confirmDate ? confirmDate : joinDate"
                @updated="loadJobDetails();$emit('updated')"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri"
        >
          <v-col cols="2">
            <span class="font-weight-bold">Band</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col cols="9">
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span v-else>
              {{ position && (position || {}).job_grade && ((position || {}).job_grade || {}).job_band ? (((position||{}).job_grade||{}).job_band||{}).value:'N/A' }}
            </span> 
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="1" />
    </v-row>

    <v-row
      no-gutters
      class="font-16 font-calibri pb-3"
    >
      <v-col
        cols="7"
        class="my-auto  font-16 font-calibri"
      >
        <span class="font-weight-bold">Workdays:</span>
        <employee-profile-job-dialog-edit-workday
          v-if="$hasPermissionTo(['update employee workdays']) && !loading && !isMyProfile && !isResigned"
          :employee-uid="employeeUid"
          @updated="loadJobDetails"
        />
      </v-col>
      
      <v-col cols="4">
        <v-row
          no-gutters
          class="font-16 font-calibri pb-3"
        >
          <v-col
            cols="2"
          >
            <span class="font-weight-bold">Position</span>
          </v-col>
          <v-col cols="1">
            :
          </v-col>
          <v-col
            cols="9"
            class="ml-n8"
          >
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
              class="loading-bar"
            />  
            <span 
              v-else
              class="ml-8"
            >
              {{ position ? (position||{}).name:'N/A' }}

              <v-tooltip
                v-if="$hasPermissionTo(['view hris employees'])"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    icon
                    color="warning"
                    x-small
                    @click="showPositionRecord = !showPositionRecord"
                  >
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>View Position History</span>
              </v-tooltip>

              <employee-profile-job-dialog-edit-position 
                v-if="$hasPermissionTo(['update employee position']) && !isMyProfile && !isResigned"
                :employee-uid="employeeUid"
                :position="position"
                @updated="loadJobDetails();$emit('updated')"
              />
            </span> 
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="6"
        class="pt-0"
      >
        <v-data-table
          :headers="headers"
          :items="workDays"
          disable-pagination
          hide-default-footer
          dense
          :style="`max-width:${width}px;border:1px solid rgba(0,0,0,.12)`"
        >
          <template v-slot:item.name="{ item }">
            <div>
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
              />  
              <span v-else>
                {{ item.name }}
              </span>
            </div>
          </template>

          <template v-slot:item.work_session="{ item }">
            <div>
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
              />  
              <span v-else>
                {{ $moment(item.work_session.start_time,'hh:mm').format('hh:mm A') }} - {{ $moment(item.work_session.end_time,'hh:mm').format('hh:mm A') }}
              </span>
            </div>
          </template>

          <template v-slot:item.leave_session.name="{ item }">
            <div>
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
              />  
              <span v-else>
                {{ item.leave_session.name }}
              </span>
            </div>
          </template>
        </v-data-table>
      </v-col> 

      <v-col
        v-if="showPositionRecord"
        cols="6"
        class="pt-0"
      >
        <v-data-table
          :headers="positionHistoryHeaders"
          :items="positionRecords"
          disable-pagination
          hide-default-footer
          dense
          :style="`max-width:600px;border:1px solid rgba(0,0,0,.12)`"
        >
          <template v-slot:item.position="{ item }">
            <div>
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
              />  
              <span v-else>
                {{ item.position.name }}
              </span>
            </div>
          </template>

          <template v-slot:item.start_date="{ item }">
            <div>
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
              />  
              <span v-else>
                {{ item.start_date ? $moment(item.start_date).format('D MMM YYYY') : 'N/A' }}
              </span>
            </div>
          </template>

          <template v-slot:item.end_date="{ item }">
            <div>
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
              />  
              <span v-else>
                {{ item.end_date ? $moment(item.end_date).format('D MMM YYYY') : 'N/A' }}
              </span>
            </div>
          </template>

          <template 
            v-slot:item.action="{ item }"
          >
            <div>
              <employee-profile-job-dialog-edit-position-record
                :position-record="item"
                :min-start-date="item.index === positionRecords.length - 1 || !(positionRecords[item.index + 1].end_date) ? joinDate : $moment(positionRecords[item.index + 1].end_date).format('YYYY-MM-DD')"
                :max-end-date="item.index > 0 ? $moment(positionRecords[item.index - 1].start_date).format('YYYY-MM-DD') : ''"
                @updated="loadJobDetails()"
              />         
            </div>
          </template>
        </v-data-table>
      </v-col>            
    </v-row>

    <v-row
      v-if="$hasPermissionTo(['view hris employees'])"
      no-gutters
      class="font-16 font-calibri pb-3"
    >
      <v-col
        cols="6"
        class="mt-5 font-16 font-calibri"
      >
        <span class="font-weight-bold">Attendance User ID: </span>
        <span>{{ (user || {}).user_id ? (user || {}).user_id : ' N/A ' }}</span>
        <employee-profile-job-dialog-edit-user-id
          v-if="$hasPermissionTo(['update employees']) && !loading && !isMyProfile && !isResigned"
          :user-uid="(user || {}).user_uid"
          :user-id="(user || {}).user_id ? (user || {}).user_id : 0"
          @updated="loadJobDetails()"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="4"
        class="font-16 font-calibri"
      >
        <span class="font-weight-bold">Superior:</span> 
        <employee-profile-job-dialog-edit-superior
          v-if="$hasPermissionTo(['update employee reporting line']) && !loading && !isMyProfile && !isResigned"
          :employee-uid="employeeUid"
          @updated="loadJobDetails(); $emit('updated')"
        />

        <v-row>
          <v-col cols="12">
            <v-card v-if="reportTo.employee_uid !== undefined">
              <v-skeleton-loader
                v-if="loading"
                style="height:71px"
                type="image"
              />
              <v-list-item v-else>
                <v-list-item-avatar 
                  class="mr-4" 
                  size="55"
                >
                  <img 
                    :src="superior.thumbnail_url" 
                    onerror="this.src='img/thumbnail.jpg'" 
                    alt="Superior Image"
                  >
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="px-0">
                    {{ superiorPerson.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle> {{ isSuperiorResigned(superior.end_date) ? 'Resigned' : (superior.is_active ? 'Active' : 'On Leave') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>

            <span v-else>No superior yet</span>
          </v-col>
        </v-row>
      </v-col>

      <v-col
        cols="8"
        class="font-16 font-calibri"
      >
        <span class="font-weight-bold">Subordinate(s):</span>
        <employee-profile-job-dialog-edit-subordinates
          v-if="$hasPermissionTo(['update employee reporting line']) && !loading && !isMyProfile && !isResigned"
          :employee-uid="employeeUid"
          @updated="loadJobDetails()"
        />
        <v-row>
          <v-col
            v-for="subordinate in subordinates"
            :key="subordinate.employee_uid"
            cols="6"
          >
            <v-card>
              <v-skeleton-loader
                v-if="loading"
                style="height:71px"
                type="image"
              />
              <v-list-item v-else>
                <v-list-item-avatar 
                  class="mr-4" 
                  size="55"
                >
                  <img 
                    :src="subordinate.employee.thumbnail_url" 
                    onerror="this.src='img/thumbnail.jpg'" 
                    alt="Subordinate Image"
                  >
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="px-0">
                    {{ subordinate.employee.person.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle> {{ subordinate.employee.is_active ? 'Active' : 'On Leave' }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item> 
            </v-card>
          </v-col>

          <v-col
            v-if="noOfSubordinates < 1"
            cols="12"
          >
            <span>No subordinates yet</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileJobDialogEditJoinDate: () => import('@/components/hris/employee/profile/job/DialogEditJoinDate'),
      EmployeeProfileJobDialogEditDepartment: () => import('@/components/hris/employee/profile/job/DialogEditDepartment'),
      EmployeeProfileJobDialogEditConfirmDate: () => import('@/components/hris/employee/profile/job/DialogEditConfirmDate'),
      EmployeeProfileJobDialogEditPosition: () => import('@/components/hris/employee/profile/job/DialogEditPosition'),
      EmployeeProfileJobDialogEditBaseLocation: () => import('@/components/hris/employee/profile/job/DialogEditBaseLocation'),
      EmployeeProfileJobSeparationDialogCreate: () => import('@/components/hris/employee/profile/job/separation/DialogCreate'),
      EmployeeProfileJobDialogEditWorkday: () => import('@/components/hris/employee/profile/job/DialogEditWorkday'),
      EmployeeProfileJobDialogEditSuperior: () => import('@/components/hris/employee/profile/job/DialogEditSuperior'),
      EmployeeProfileJobDialogEditSubordinates: () => import('@/components/hris/employee/profile/job/DialogEditSubordinates'),
      EmployeeProfileJobSeparationDialogList: () => import('@/components/hris/employee/profile/job/separation/DialogList'),
      EmployeeProfileJobRehireDialogEdit: () => import('@/components/hris/employee/profile/job/rehire/DialogEdit'),
      EmployeeProfileJobDialogEditUserId: () => import('@/components/hris/employee/profile/job/DialogEditUserId'),
      EmployeeProfileJobDialogEditProbationDueDate: () => import('@/components/hris/employee/profile/job/DialogEditProbationDueDate'),
      EmployeeProfileJobDialogEditPositionRecord: () => import('@/components/hris/employee/profile/job/DialogEditPositionRecord'),
      EmployeeProfileJobDialogListDepartments: () => import('@/components/hris/employee/profile/job/DialogListDepartments'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        joinDate: null,
        confirmDate: null,
        yearOfService: null,
        department: null,
        position: null,
        baseLocation: null,
        lastWorkingDate: null,
        effectiveDate: null,
        basicSalary: null,
        loading: false,
        section: null,
        state: null,
        city: null,
        workDays: [],
        headings: [
          {
            text: 'Workday', 
            sortable: false, 
            value: 'name',
            divider: true,
            width: 128,
          },
          {
            text: 'Session',
            sortable: false,
            value: 'work_session',
            divider: true,
            width: 197,
          },
        ],
        reportTo: {},
        user: {},
        subordinates: [],
        probationData: [],
        currentNormalHireProbation: {},
        showPositionRecord: false,
        positionRecords: [],
        positionHistoryHeadings: [
          {
            text: 'Position', 
            sortable: false, 
            value: 'position.name',
            divider: true,
            width: 220,
          },
          {
            text: 'Start Date',
            sortable: false,
            value: 'start_date',
            divider: true,
            width: 120,
            align: 'center',
          },  
          {
            text: 'End Date', 
            sortable: false, 
            value: 'end_date',
            divider: true,
            width: 120,
            align: 'center',
          },                   
        ],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      width () {
        if (this.headers.length < 3) {
          return 328
        }
        return 500
      },
      headers () {
        let originalTab = [...this.headings]
        if (this.$hasPermissionTo(['update employee workdays'])) {
          originalTab.splice(originalTab.length, 0, {
            text: 'Leave Session',
            sortable: false,
            align: 'center',
            value: 'leave_session.name',
            width: 173,
          })
        }

        return originalTab
      },
      positionHistoryHeaders () {
        let originalTab = [...this.positionHistoryHeadings]
        if (this.$hasPermissionTo(['update employee position']) && !this.isMyProfile && !this.isResigned) {
          originalTab.splice(originalTab.length, 0, {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
            width: 50,
          })
        }

        return originalTab
      },
      superior () {
        return (this.reportTo || {})
      },
      superiorPerson () {
        return (this.reportTo.person || {})
      },
      noOfSubordinates () {
        return this.subordinates.length
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadJobDetails()
          }
        },
      },
    },
  
    methods: {
      loadJobDetails () {
        this.loading = true

        Promise.all([
          this.$api.jobDetails().list(this.employeeUid),
          this.$api.hrisEmployeeWorkDays().list(this.employeeUid),
          this.$api.hrisReportTo().show(this.employeeUid),
          this.$api.hrisSubordinates().list(this.employeeUid),
          this.$api.hrisEmployeePositions().list(this.employeeUid),
        ])
          .then(([jobDetails, workDay, reportTo, subordinates, positionRecords]) => {
            this.joinDate = jobDetails.data.joined_date
            this.confirmDate = jobDetails.data.confirmed_date
            this.department = jobDetails.data.department
            this.section = jobDetails.data.section
            this.lastWorkingDate = jobDetails.data.last_working_date
            this.effectiveDate = jobDetails.data.end_date
            this.position = (jobDetails.data.current_position || {}).position
            this.probationData = jobDetails.data.employee_probations
            this.user = (jobDetails.data.person || {}).user
            this.positionRecords = _.orderBy(positionRecords.data, ['created_at'], ['desc'])

            this.positionRecords = this.positionRecords.map((item, index) => ({
              index: index,
              ...item,
            }))

            const normalHireProbations = this.probationData.filter(probation => { 
              return probation.type === 'normal hire' && probation.start_date === this.joinDate
            })

            this.currentNormalHireProbation = normalHireProbations[0]

            let noOfDaysInCurrentYear = this.$moment().endOf('year').diff(this.$moment().startOf('year'), 'days') + 1 // includes day 1
            this.yearOfService = ((this.$moment().diff(this.$moment(jobDetails.data.joined_date), 'days') + 1) / noOfDaysInCurrentYear).toFixed(2)
            if (jobDetails.data.end_date) {
              this.yearOfService = ((this.$moment(jobDetails.data.end_date).diff(this.$moment(jobDetails.data.joined_date), 'days') + 1) / noOfDaysInCurrentYear).toFixed(2)
            }
            this.baseLocation = ((jobDetails.data || {}).city || {}).name + ', ' + (((jobDetails.data || {}).city || {}).state || {}).name

            this.city = (jobDetails.data || {}).city
            this.state = ((jobDetails.data || {}).city || {}).state
            
            this.workDays = _.orderBy(workDay.data, ['day'], ['asc'])

            this.workDays.map(item => {
              if (item.leave_session.name === 'None') {
                item.leave_session.name = 'No Restriction'
              } else if (item.leave_session.name === 'A.M') {
                item.leave_session.name = 'A.M only'
              } else if (item.leave_session.name === 'P.M') {
                item.leave_session.name = 'P.M only'
              } else {
                item.leave_session.name = 'Full Day'
              }
            })

            this.setNamesForDay()

            // temp solution to let HR able to clean up data
            this.reportTo = reportTo.data || {}
            /// ////////////////////////////////////////////////

            this.subordinates = subordinates.data || []    

            this.loading = false
          })
      },

      calculateProbationDueDate (joinDate, category) {
        if (this.currentNormalHireProbation) {
          return this.$moment(this.currentNormalHireProbation.end_date).format('D MMM YYYY')
        } else {
          if (category) {
            if (category.name === 'Non Executive') {
              return this.$moment(joinDate).add(3, 'M').format('D MMM YYYY')
            } else {
              return this.$moment(joinDate).add(6, 'M').format('D MMM YYYY')
            }
          } else {
            return 'N/A' // old records have no position data
          }
        }
      },

      setNamesForDay () {
        let names = [
          'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
        ]
        this.workDays.map(function (workday, index) {
          Object.assign(workday, { name: names[index] })
        })
      },

      isEmployeeResigned (endDate) {
        return endDate !== null
      },
      isSuperiorResigned (endDate) {
        return endDate !== null && endDate <= this.$moment().format('YYYY-MM-DD')
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px;
  height:25px;
} 
</style>
